// EIP-681-style payment-request URIs (Ethereum) and the Tron equivalent
// convention, encoded into Receive's QR codes (feature-harden.md section 3
// / COMPATIBILITY.md's "Payment request URIs" gap). Lets a scanning wallet
// recognize which chain an address belongs to and pre-fill it correctly,
// instead of relying on guessing from a bare address string. Address-only
// (no amount/memo) — the payment-request-with-amount feature was built
// once and explicitly removed later (commit 6dd5ce0, "to be rebuilt
// later"); this only changes how Receive's existing address gets encoded
// into a QR code, not a reintroduction of that removed feature.
const CHAIN_ID_MAINNET = 1;
const CHAIN_ID_SEPOLIA = 11155111;

// Matches tether.worker.js's networkKey(): undefined/anything but false
// fails safe onto testnet, same as every other chain-network decision in
// this codebase (CLAUDE.md: "default to testnet in local dev").
function isTestnet(testnetEnabled) {
  return testnetEnabled !== false;
}

export function buildPaymentUri(chain, address, testnetEnabled) {
  if (!address) return '';
  if (typeof chain === 'string' && chain.startsWith('Tron')) {
    // No formally standardized EIP-681 equivalent exists for Tron; `tron:`
    // as a URI scheme is the real convention other Tron-aware wallets
    // (TronLink, TokenPocket) already use for QR-encoded addresses. Tron
    // addresses are self-describing (base58check, no mainnet/testnet
    // format difference), so there's no chain-id-style suffix to add.
    return `tron:${address}`;
  }
  const chainId = isTestnet(testnetEnabled) ? CHAIN_ID_SEPOLIA : CHAIN_ID_MAINNET;
  return `ethereum:${address}@${chainId}`;
}
